// @ts-nocheck
import styled from 'styled-components';

export const DataFeesTooltipStyled = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  max-height: 400px;
  overflow: scroll;

  .dataFeesTooltip {

    &__header {
      background: ${props => props.theme.grayDark};
      border-bottom: 1px solid ${props => props.theme.grayUltraUltraLight};
      color: ${props => props.theme.uiColors.tooltipTextColorAlternative};
      padding: 0 8px;
    }

    &__campaign {
      &Name {
        background: ${props => props.theme.brand};
        color: ${props => props.theme.uiColors.tooltipTextColorAlternative};
        font-style: italic;
        padding: 0 8px;
      }

      &EmptyState {
        color: ${props => props.theme.gray};
        padding: 0 8px;
      }

      &DataFee {
        border-bottom: 1px solid ${props => props.theme.grayUltraUltraLight};
        color: ${props => props.theme.gray};
        padding: 0 8px;
        display: flex;
        justify-content: space-between;

        &Concept {
          flex: 1 0 70%;
        }
        &Cost {
          flex: 1 0 30%;
          display: flex;
          justify-content: end;
        }
      }
    }
  }
`;
